import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { AppConstants } from 'src/app/classes/app/constants';
import { EImgIcons, EAppIcons, EAppIconsStandard } from 'src/app/classes/def/app/icons';
import { Messages } from 'src/app/classes/def/app/messages';
import { IBookingInfoContent, IStoryProductBooking } from 'src/app/classes/def/core/booking';
import { ErrorMessage } from 'src/app/classes/general/error-message';
import { TimeUtils } from 'src/app/classes/general/time';
import { Util } from 'src/app/classes/general/util';
import { IDateSelectorEntry } from 'src/app/modals/generic/modals/date-selector/date-selector.component';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';


export enum EBookingCheckAction {
  showInfo = 1,
  openStoryPage = 2
}

export interface IBookingCheckReturn {
  action: number;
  data: IBookingInfoContent;
}

@Component({
  selector: 'booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss'],
})
export class BookingFormComponent implements OnInit, OnDestroy {
  imgIcons = EImgIcons;
  appIcons = EAppIcons;
  appIconsStandard = EAppIconsStandard;

  privacyPolicyLabel: string = "<view privacy policy>";
  agreementLabel: string = "I agree to the processing of my personal data.";
  agreementContactLabel: string = "I agree to be contacted by email/sms regarding customer support and important updates.";
  agreementFooterLabel: string = "You can withdraw your consent at any time by contacting us.";
  bookingDateLabel: string = "*select a date for your scheduled free pass";

  consent = {
    general: false,
    contact: false
  };


  @Input()
  introLabel: string = "Book now";

  @Input()
  submitLabel: string = "Submit";

  @Input()
  footerLabel: string = "";

  @Input()
  bookingDateSelector: IDateSelectorEntry = {
    id: 'pd',
    heading: 'Booking Date*',
    code: 1,
    full: true,
    dateOnly: true
  };

  @Input()
  bookingData: IStoryProductBooking = {
    customerEmail: null,
    customerName: null,
    customerPhone: null,
    bookingAmount: 1
  };

  @Output()
  submit: EventEmitter<IStoryProductBooking> = new EventEmitter();

  constructor(
    private uiext: UiExtensionService
  ) {

  }

  ngOnInit() {

  }

  checkPhone(event: any) {
    console.log("check phone: ", event);
    this.bookingData.customerPhone = event;
  }

  checkPhoneValid(event: any) {
    console.log("check phone valid: ", event);
    this.bookingData.customerPhoneValid = event;
  }

  submitForm() {
    let missingFormFields: string = "(";
    let validationErrors: string = "";

    let isMissingFormFields: boolean = false;
    let isValidationErrors: boolean = false;

    if (this.bookingDateSelector.value == null) {
      missingFormFields += "review date";
      isMissingFormFields = true;
    }
    if (this.bookingData.customerEmail == null) {
      missingFormFields += (isMissingFormFields ? ", " : "") + "email";
      isMissingFormFields = true;
    }
    if (this.bookingData.customerName == null) {
      missingFormFields += (isMissingFormFields ? ", " : "") + "name";
      isMissingFormFields = true;
    }

    missingFormFields += ")";
    // if (this.bookingData.customerPhone == null) {
    //   missingFormFields += isMissingFormFields ? ", " : "" + "phone";
    // }

    if (this.bookingData.customerPhone != null && !this.bookingData.customerPhoneValid) {
      // check proper format
      validationErrors += "phone number invalid format";
      isValidationErrors = true;
    } else if (this.bookingData.customerPhoneValid) {
      // remove all whitespaces
      this.bookingData.customerPhone = this.bookingData.customerPhone.replace(/ /g, "");
    }

    let bookingDate: string = TimeUtils.removeTimePart(this.bookingDateSelector.value);
    this.bookingData.bookingTimestamp = bookingDate as any;

    console.log("submit form: ", this.bookingData);
    console.log("missing form fields: ", isMissingFormFields);

    if (isMissingFormFields) {
      this.uiext.showAlertNoAction(Messages.msg.formRequiredFields.after.msg, Messages.msg.formRequiredFields.after.sub + " " + missingFormFields, false);
      return;
    }

    if (isValidationErrors) {
      this.uiext.showAlertNoAction(Messages.msg.formRequiredFields.after.msg, validationErrors, false);
      return;
    }

    this.submit.next(this.bookingData);
  }

  onSelectAgreed(event: any) {
    setTimeout(() => {
      if (this.consent.general) {
        this.consent.contact = true;
      } else {
        this.consent.contact = false;
      }
    }, 1);
  }

  openTerms() {
    this.openLink(AppConstants.links.termsUrl);
  }

  openLink(url: string) {
    if (!url) {
      return;
    }
    Util.openURLAdaptive(url);
  }

  ngOnDestroy() {

  }

}
